import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import Field from '../../../../../../../components/Form/Field'
import Form from '../../../../../../../components/Form'
import SocialMediaAccountsSection from '../../../ReusableSections/SocialMediaAccountsSection'
import BrandKeywordsSection from '../../../ReusableSections/BrandKeywordsSection'

import { usePurifiedFormik } from '../../../../../../../hooks/formHooks/usePurifiedFormik'

import { createRight, clearCreateRight } from '../../../../../../../modules/actions/rights'
import {
  createdRightErrorSelector,
  createdRightIsLoadingSelector,
  rightWasCreatedSelector
} from '../../../../../../../modules/selectors/rights'
import { selectedPartnershipSelector } from '../../../../../../../modules/selectors/partnerships'

import { POST_RIGHT_CREATE } from '../../../../../../../constants/forms'
import { INCLUDE_LINKED_INSTAGRAM_ACCOUNT, LINKED_INSTAGRAM_ACCOUNT, NAME } from '../../../fields'

import { validationSchema } from './validation'
import { initialValues } from './fields'
import { transformValuesToBE } from './formatters'

import useDrawerFormClasses from '../../../../../../../styles/common/drawerForms'

const ShortPostRightCreateForm = () => {
  const drawerFormClasses = useDrawerFormClasses()

  const dispatch = useDispatch()

  const rightWasCreated = useSelector(rightWasCreatedSelector)
  const { id: partnershipId } = useSelector(selectedPartnershipSelector)

  const onSubmit = useCallback(
    values => {
      const transformedData = transformValuesToBE(values)

      const includeInstagramAccount = values[INCLUDE_LINKED_INSTAGRAM_ACCOUNT]
      const instagramAccount = values[LINKED_INSTAGRAM_ACCOUNT]

      const rightData = {
        ...transformedData,
        partnership: partnershipId,
        ...(includeInstagramAccount &&
          instagramAccount && {
            instagram_accounts: [instagramAccount]
          })
      }
      dispatch(createRight(rightData))
    },
    [dispatch, partnershipId]
  )

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const clearCreateRightSubmit = useCallback(() => dispatch(clearCreateRight()), [dispatch])

  return (
    <Form
      formik={purifiedFormik}
      formName={POST_RIGHT_CREATE}
      successSubmit={rightWasCreated}
      errorSelector={createdRightErrorSelector}
      isLoadingSelector={createdRightIsLoadingSelector}
      clearHandler={clearCreateRightSubmit}
    >
      <section className={drawerFormClasses.section}>
        <h3 className={drawerFormClasses.sectionTitle}>Report name</h3>
        <Field formik={purifiedFormik} id={NAME} name={NAME} placeholder="Name of report" />
      </section>
      <SocialMediaAccountsSection formik={purifiedFormik} />
      <BrandKeywordsSection formik={purifiedFormik} />
    </Form>
  )
}

export default ShortPostRightCreateForm
